<template>
    <div id="video" class="video">
        <!-- 标题 -->
        <div class="video-row">
            <div class="video-header">
                <span v-if="isMobile" style="color:F8F2D8;">{{$t("video")}}</span>
            </div>
        </div>
        <!-- 视频 -->
        <div class="video-row">
            <div class="swiper-box">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div
                            class="swiper-slide"
                            @mouseenter="show_btnPlay=true"
                            @mouseleave="show_btnPlay=false"
                        >
                            <video
                                src="@assets/video/p20n-cn-01.mp4"
                                loop
                                :controls="showControl"
                            ></video>
                            <div
                                v-show="show_btnPlay || !video_isplaying"
                                class="btn-play"
                                @click="videoPlay($event)"
                            >
                                <div v-show="video_btnIcon=='play'" class="play"></div>
                                <div v-show="video_btnIcon=='pause'" class="pause"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 如果需要分页器 -->
                <div class="swiper-pagination page"></div>
                <!-- 如果需要导航按钮 -->
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";

export default {
    props: {
        isMobile: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            show_btnPlay: true,
            video_isplaying: false,
            video_btnIcon: "play",
            showControl: false
        };
    },
    watch: {
        showControl(to) {}
    },
    components: {},
    mounted() {
        this._initSwiper();
        let v = document.querySelectorAll(".video-row video");
        v.forEach(item => {
            item.onplay = this.onVideoPlay;
            item.onpause = this.onVideoPause;
        });
    },
    methods: {
        onVideoPlay(e) {
            this.video_isplaying = true;
            this.video_btnIcon = "pause";
        },
        onVideoPause(e) {
            this.video_isplaying = false;
            this.video_btnIcon = "play";
        },
        // 播放视频
        videoPlay(e) {
            // console.log(e)
            if ($(e.currentTarget).prev()[0].paused) {
                $(e.currentTarget)
                    .prev()[0]
                    .play();
                this.video_isplaying = true;
                this.video_btnIcon = "pause";
            } else {
                $(e.currentTarget)
                    .prev()[0]
                    .pause();
                this.video_isplaying = false;
                this.video_btnIcon = "play";
            }
        },
        // 暂停视频
        pauseVideo() {
            $("#video .swiper-slide video").each(function() {
                $(this)[0].pause();
            });
            this.video_isplaying = false;
            this.video_btnIcon = "play";
        },
        // Swiper
        _initSwiper() {
            let that = this;
            let mySwiper = new Swiper("#video .swiper-container", {
                initalSlide: 2, //设定初始化时slide的索引，
                // direction: "vertical",//slide的滑动方向
                speed: 500, //滑动速度，开始滑动到结束滑动的时间
                autoplay: 500, //可选选项，自动滑动,值为自动滑动的间隔
                autoplayDisableOnInteraction: false, //操作后是否停止自动滑动
                autoplayStopOnLast: false, //设置为true，切换到最后一个slide时停止自动切换
                grabCursor: true, //拖动时指针会变成抓手形状
                loop: false, // 循环
                // 分页器 - 即小圆点
                pagination: {
                    el: "#video .swiper-pagination",
                    clickable: true, //可点击切换
                    type: "bullets" //bullets 圆点（默认） fraction 分式 progressbar 进度条 custom 自定义
                },
                // 左右的切换按钮
                navigation: {
                    nextEl: "#video .swiper-button-next",
                    prevEl: "#video .swiper-button-prev"
                },
                on: {
                    slideChange: function() {
                        that.pauseVideo();
                    }
                },
                preventClicks: false
            });
        }
    }
};
</script>

<style lang="scss">
.video {
    height: 100%;
    min-height: 800px;
    padding: 70px 0 0;
    .video-row {
        width: 100%;
        display: flex;
        justify-content: center;
        .video-header {
            background: url("~@assets/imgs/video-text-cn.png") center center
                no-repeat;
            background-size: 100% auto;

            width: 350px;
            height: 100px;
            margin-top: 50px;
            img {
                width: 100%;
            }
        }
        .swiper-box {
            margin: 0 auto;
            width: 1200px;
            position: relative;
            padding: 50px 0;
            .swiper-container {
                width: 1000px;
                .swiper-wrapper {
                    .swiper-slide {
                        width: 100%;
                        position: relative;
                        video {
                            width: 100%;
                            height: 100%;
                            border: 5px solid #b49150;
                        }
                        .btn-play {
                            width: 100px;
                            height: 60px;
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            margin-left: -50px;
                            margin-top: -30px;
                            z-index: 20;
                            border-radius: 10px;
                            background: rgba(0, 0, 0, 0.5);
                            text-align: center;
                            line-height: 40px;
                            cursor: pointer;
                            .play {
                                border-top: 15px solid transparent;
                                border-left: 30px solid #fff;
                                border-bottom: 15px solid transparent;
                                border-right: 10px solid transparent;
                                position: absolute;
                                left: 35px;
                                top: 15px;
                            }
                            .pause {
                                width: 33px;
                                height: 24px;
                                background: url("~@assets/imgs/pause.png")
                                    center center no-repeat;
                                background-size: 100% 100%;
                                position: absolute;
                                left: 32px;
                                top: 18px;
                            }
                        }
                        .btn-play:hover {
                            background: rgba(0, 0, 0, 0.8);
                        }
                    }
                }
            }
            // 分页按钮
            .swiper-pagination {
                width: 1200px;
                height: 50px;
                line-height: 50px;
                .swiper-pagination-bullet {
                    width: 12px;
                    height: 12px;
                    margin: 0 5px;
                    background: #fff;
                    opacity: 0.8;
                    transition: all 0.1s linear;
                    outline: none;
                }
                .swiper-pagination-bullet-active {
                    background: #f00;
                }
            }
            // 翻页按钮
            .swiper-button-prev,
            .swiper-button-next {
                width: 50px;
                height: 50px;
                outline: none;
                top: 100%;
                margin-top: -50px;
                border-radius: 50%;
            }
            .swiper-button-prev {
                background: url("~@assets/imgs/btn_prev.png") center center
                    no-repeat;
                background-size: 50% 60%;
                background-color: rgba(0, 0, 0, 0.3);
                left: 120px;
            }
            .swiper-button-next {
                background: url("~@assets/imgs/btn_next.png") center center
                    no-repeat;
                background-size: 50% 60%;
                background-color: rgba(0, 0, 0, 0.3);
                right: 120px;
            }
        }
    }
}
@media screen and (max-width: 1440px) {
    .video {
        .video-row {
            .swiper-box {
                width: 800px;
                .swiper-container {
                    width: 680px;
                }
                // 分页按钮
                .swiper-pagination {
                    width: 800px;
                }
            }
        }
    }
}
// 移动端
@media screen and (max-width: 768px) {
    .video {
        height: auto;
        min-height: 300px;
        padding: 0;
        background: url("~@assets/imgs/bgphone-p20n.png") center top
            no-repeat;
        background-size: 100%;
        .video-row {
            flex-direction: column;
            .video-header {
                width: 250px;
                height: 60px;
                margin: 20px auto 0;
            }
            .swiper-box {
                width: 80%;
                padding: 20px 0 50px;
                .swiper-container {
                    width: 100%;
                    .swiper-wrapper {
                        .swiper-slide {
                            width: 500px;
                            position: relative;
                            .btn-play {
                                width: 80px;
                                height: 40px;
                                line-height: 40px;
                                margin-left: -40px;
                                margin-top: -20px;
                                .play {
                                    border-top: 12px solid transparent;
                                    border-left: 23px solid #fff;
                                    border-bottom: 12px solid transparent;
                                    border-right: 10px solid transparent;
                                    position: absolute;
                                    left: 30px;
                                    top: 7px;
                                }
                                .pause {
                                    width: 33px;
                                    height: 24px;
                                    background: url("~@assets/imgs/pause.png")
                                        center center no-repeat;
                                    background-size: 100% 100%;
                                    position: absolute;
                                    left: 24px;
                                    top: 7px;
                                }
                            }
                            .btn-play:hover {
                                background: rgba(50, 50, 50, 0.5);
                            }
                        }
                    }
                }
                // 分页按钮
                .swiper-pagination {
                    width: 100%;
                    height: 30px;
                    line-height: 30px;
                }
                // 翻页按钮
                .swiper-button-prev,
                .swiper-button-next {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                }
                .swiper-button-prev {
                    left: 10%;
                }
                .swiper-button-next {
                    right: 10%;
                }
            }
        }
    }
}
@media screen and (max-width: 500px) {
    #video {
        padding: 0;
        .video-row {
            .video-header {
                width: 100%;
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                font-weight: bold;
                color: #f8f2d8;
                background: url("~@assets/imgs/bgphone-title.png") center
                    center no-repeat;
                background-size: 330px 35px;
                text-align: center;
            }
            .swiper-box {
                width: 90%;
                .swiper-container {
                    width: 100%;
                    margin-bottom: 5px;
                    .swiper-wrapper {
                        width: 100%;
                        .swiper-slide {
                            width: 95%;
                            text-align: center;
                            video {
                                width: 100%;
                                height: 100%;
                            }
                            .btn-play {
                            }
                        }
                    }
                }
                // 分页按钮
                .swiper-pagination {
                    width: 100%;
                }
                // 翻页按钮
                .swiper-button-prev,
                .swiper-button-next {
                    height: 25px;
                }
                .swiper-button-prev {
                    left: 40px;
                }
                .swiper-button-next {
                    right: 40px;
                }
            }
        }
    }
}
@media screen and (max-width: 375px) {
}
</style>



// WEBPACK FOOTER //
// src/components/Video.vue